import {
    hblCols as oimHblCols,
    hblCols2 as oimHblCols2,
    cntrCols as oimCntrCols,
    hblGroupingModel as oimHblGroupingModel,
    hblGroupingModel2 as oimHblGroupingModel2,
    cntrGroupingModel as oimCntrGroupingModel,
    linkCols as oimLinkCols,
} from 'features/shipments/components/TableDefinition/OceanImportSubDef';
import {
    hblCols1 as oexHblCols,
    hblCols2 as oexHblCols2,
    cntrCol as oexCntrCols,
    hblGroupingModel as oexHblGroupingModel,
    hblGroupingModel2 as oexHblGroupingModel2,
    cntrGroupingModel as oexCntrGroupingModel,
} from 'features/shipments/components/TableDefinition/OceanExportSubDef';
import {
    hblCol as aimHblCols,
    hblCol2 as aimHblCols2,
    hblAliasCol as aimAliasCols,
    hblGroupingModel as aimHblGroupingModel,
    hblGroupingModel2 as aimHblGroupingModel2,
    hblAliasGroupingModel as aimAliasGroupingModel,
    linkCols as aimLinkCols,
} from 'features/shipments/components/TableDefinition/AirImportSubDef';
import {
    hblCol as aexHblCols,
    hblAliasCol as aexAliasCols,
    hblGroupingModel as aexHblGroupingModel,
    hblAliasGroupingModel as aexAliasGroupingModel,
} from 'features/shipments/components/TableDefinition/AirExportSubDef';

import {
    oim_preset_columns,
    oim_preset_keys,
    oex_preset_columns,
    oex_preset_keys,
    aim_preset_columns,
    aim_preset_keys,
    aex_preset_columns,
    aex_preset_keys,
    trucking_preset_columns,
    trucking_preset_keys,
} from './constantsData';

/** Map column settings as an object. */
export const columnConfigMap = {
    oimHblCols: oimHblCols,
    oimHblCols2: oimHblCols2,
    oimCntrCols: oimCntrCols,
    oimHblGroupingModel: oimHblGroupingModel,
    oimHblGroupingModel2: oimHblGroupingModel2,
    oimCntrGroupingModel: oimCntrGroupingModel,
    oexHblCols: oexHblCols,
    oexHblCols2: oexHblCols2,
    oexCntrCols: oexCntrCols,
    oexHblGroupingModel: oexHblGroupingModel,
    oexHblGroupingModel2: oexHblGroupingModel2,
    oexCntrGroupingModel: oexCntrGroupingModel,
    aimHblCols: aimHblCols,
    aimHblCols2: aimHblCols2,
    aimAliasCols: aimAliasCols,
    aimHblGroupingModel: aimHblGroupingModel,
    aimHblGroupingModel2: aimHblGroupingModel2,
    aimAliasGroupingModel: aimAliasGroupingModel,
    aexHblCols: aexHblCols,
    aexAliasCols: aexAliasCols,
    aexHblGroupingModel: aexHblGroupingModel,
    aexAliasGroupingModel: aexAliasGroupingModel,
    oimLinkCols: oimLinkCols,
    aimLinkCols: aimLinkCols,
};

/** Keys that are not allowed to have Null value.  */
export const notAllowNullKey = [
    'pre_alert',
    'isf',
    'hbl_release',
    'customs',
    'customs_hold',
    'delivery_order',
    'proof',
    'stages',
    'pierpass',
    'empty',
    'import_service_fee',
    'arrival_notice',
    'ocean_freight',
    'booking_confirmation',
    'paid_with',
    'air_freight',
    'dg_hazmat',
    'aes_itn',
    'shipping_instruction',
    'invoice',
    'crdr',
];

export const dateField = [
    'paid_on',
    'booking_confirmation_date',
    'dg_hazmat_date',
    'shipping_instruction_date',
    'aes_itn_date',
    'invoice_date',
    'crdr_date',
    'proof_date',
    'perdiem',
    'empty_date',
    'stages_date',
    'import_service_fee_date',
    'alias_etd',
    'alias_eta',
];

export const oimTabConfig = {
    hasSplit: true,
    hasSecondTable: true,
    minHeight: 370,
    height: 'auto',
    columns: [
        'oimHblCols',
        'oimHblCols2',
        'oimCntrCols',
        'oimHblGroupingModel',
        'oimHblGroupingModel2',
        'oimCntrGroupingModel',
        'oimLinkCols',
    ],

    houseData: 'oimHblUpdateForm',
    containerData: 'oimContainerUpdateForm',
    presetData: 'oimPresetUpdateForm',

    tableName: ['il_ocean_import', 'il_ocean_import_hbl', 'il_ocean_import_cntr'],
    keyName: ['il_ocean_import_id', 'il_ocean_import_hbl_id'],

    addReducer: ['', 'addOimHBL', 'addOimContainer', ''],
    updateReducer: ['setOimMainUpdateData', 'setOimHblFormData', 'setOimContainerFormData', ''],
    deleteReducer: ['', 'deleteOimHBL', 'deleteOimContainer', ''],

    newHBL: {
        hbl: '',
        il_trade_partner_id_shipper: '',
        il_trade_partner_id_consignee: '',
        hbl_link: '',
        hbl_quantity: '',
        il_opus_volume_unit_id: '',
        pre_alert: 'Not Sent',
        isf: '-',
        isf_link: '',
        hbl_release: '-',
        customs: 'Pending',
        customs_hold: '-',
        customs_link: '',
        customs_other: '',
        arrival_notice: 'Waiting',
        arrival_notice_link: '',
        invoice: 'Pending',
        invoice_link: [],
        invoice_date: null,
        crdr: 'Pending',
        crdr_link: [],
        crdr_date: null,
    },
    newCNTR: {
        cntr_number: '',
        volume: '',
        pierpass: 'Unpaid',
        il_trade_partner_id: '',
        delivery_order: '-',
        deliver_order_link: '',
        proof: 'Waiting',
        proof_link: '',
        proof_date: null,
        perdiem: null,
        empty_date: null,
        empty: 'Not Returned',
        pickup_number: '',
    },
    newAlias: {
        alias_name: '',
        alias_bol_number: '',
        alias_bol_link: '',
        alias_quantity: 0,
        il_opus_volume_unit_id: '',
        il_location_id_pick_up: '',
        il_location_id_deliver_to: '',
        alias_etd: null,
        alias_eta: null,
        il_trade_partner_id: '',
        alias_shipment_type: '-',
    },

    presetTableName: 'il_preset_ocean_import',
    presetColumn: oim_preset_columns,
    checkboxKeys: oim_preset_keys,
    preset: [
        { id: 1, label: 'PA', attribute: 'pre_alert' },
        { id: 2, label: 'I', attribute: 'isf' },
        { id: 3, label: 'AN', attribute: 'arrival_notice' },
        { id: 4, label: 'M', attribute: 'mbl_release' },
        { id: 5, label: 'H', attribute: 'hbl_release' },
        { id: 6, label: 'C', attribute: 'customs' },
        { id: 7, label: 'DO', attribute: 'delivery_order' },
        { id: 8, label: 'PP', attribute: 'pierpass' },
        { id: 9, label: 'E', attribute: 'empty' },
        { id: 10, label: 'IV', attribute: 'invoice' },
        { id: 11, label: 'CD', attribute: 'crdr' },
    ],
};

export const oexTabConfig = {
    hasSplit: false,
    hasSecondTable: true,
    minHeight: 200,
    height: 'auto',
    columns: [
        'oexHblCols',
        'oexHblCols2',
        'oexCntrCols',
        'oexHblGroupingModel',
        'oexHblGroupingModel2',
        'oexCntrGroupingModel',
        null,
    ],

    houseData: 'oexHblUpdateForm',
    containerData: 'oexContainerUpdateForm',
    presetData: 'oexPresetUpdateForm',

    tableName: ['il_ocean_export', 'il_ocean_export_hbl', 'il_ocean_export_cntr'],
    keyName: ['il_ocean_export_id', 'il_ocean_export_hbl_id'],

    addReducer: ['', 'addOexHBL', 'addOexContainer', ''],
    updateReducer: ['setOexMainUpdateData', 'setOexHblFormData', 'setOexContainerFormData', ''],
    deleteReducer: ['', 'deleteOexHBL', 'deleteOexContainer', ''],

    newHBL: {
        hbl: '',
        il_trade_partner_id_shipper: '',
        il_trade_partner_id_consignee: '',
        hbl_link: '',
        hbl_quantity: '',
        il_opus_volume_unit_id: '',
        shipping_instruction: 'Pending',
        shipping_instruction_date: null,
        aes_itn: 'Pending',
        aes_itn_number: '',
        aes_itn_date: null,
        dg_hazmat: '-',
        dg_hazmat_link: '',
        dg_hazmat_date: null,
        pre_alert: 'Not Sent',
        isf: '-',
        isf_link: '',
        hbl_release: '-',
        customs: 'Pending',
        customs_hold: '-',
        customs_other: '',
        invoice: 'Pending',
        invoice_link: [],
        invoice_date: null,
        crdr: 'Pending',
        crdr_link: [],
        crdr_date: null,
    },
    newCNTR: {
        cntr_number: '',
        seal_number: '',
        volume: '',
        il_trade_partner_id: '',
        delivery_order: '-',
        deliver_order_link: '',
        pierpass: 'Unpaid',
        stages: 'Pending',
        stages_date: null,
    },

    presetTableName: 'il_preset_ocean_export',
    presetColumn: oex_preset_columns,
    checkboxKeys: oex_preset_keys,
    preset: [
        { id: 1, label: 'BK', attribute: 'booking_confirmation' },
        { id: 2, label: 'DO', attribute: 'delivery_order' },
        { id: 3, label: 'PP', attribute: 'pierpass' },
        { id: 4, label: 'SI', attribute: 'shipping_instruction' },
        { id: 5, label: 'PC', attribute: 'portcut' },
        { id: 6, label: 'OF', attribute: 'ocean_freight' },
        { id: 7, label: 'IV', attribute: 'invoice' },
        { id: 8, label: 'CD', attribute: 'crdr' },
    ],
};

export const aimTabConfig = {
    hasSplit: false,
    hasSecondTable: true,
    minHeight: 198,
    height: 'auto',
    columns: [
        'aimHblCols',
        'aimHblCols2',
        'aimAliasCols',
        'aimHblGroupingModel',
        'aimHblGroupingModel2',
        'aimAliasGroupingModel',
        'aimLinkCols',
    ],

    houseData: 'aimHblUpdateForm',
    containerData: 'aimContainerUpdateForm',
    presetData: 'aimPresetUpdateForm',

    tableName: ['il_air_import', 'il_air_import_hbl', 'il_air_import_hbl_alias'],
    keyName: ['il_air_import_id', 'il_air_import_hbl_id'],

    addReducer: ['', 'addAimHBL', 'addAimContainer', ''],
    updateReducer: ['setAimMainUpdateData', 'setAimHblFormData', 'setAimContainerFormData', ''],
    deleteReducer: ['', 'deleteAimHBL', 'deleteAimContainer', ''],

    newHBL: {
        hawb: '',
        il_trade_partner_id_shipper: '',
        il_trade_partner_id_consignee: '',
        hawb_link: '',
        pre_alert: 'Not Sent',
        import_service_fee: 'Pending',
        import_service_fee_link: '',
        import_service_fee_date: null,
        arrival_notice: 'Waiting',
        arrival_notice_link: '',
        invoice: 'Pending',
        invoice_link: [],
        invoice_date: null,
        crdr: 'Pending',
        crdr_link: [],
        crdr_date: null,
    },
    newCNTR: {
        alias: '',
        il_opus_vessel_id: '',
        quantity: 0,
        il_opus_volume_unit_id: '',
        weight: 0,
        customs: 'Pending',
        customs_hold: '-',
        customs_link: '',
        customs_other: '',
        il_trade_partner_id: '',
        delivery_order: '-',
        deliver_order_link: '',
        proof: 'Waiting',
        proof_link: '',
        proof_date: null,
        il_location_id_deliver_to: '',
    },

    presetTableName: 'il_preset_air_import',
    presetColumn: aim_preset_columns,
    checkboxKeys: aim_preset_keys,
    preset: [
        { id: 1, label: 'PA', attribute: 'pre_alert' },
        { id: 2, label: 'C', attribute: 'customs' },
        { id: 3, label: 'AF', attribute: 'air_freight' },
        { id: 4, label: 'IS', attribute: 'import_service_fee' },
        { id: 5, label: 'AN', attribute: 'arrival_notice' },
        { id: 6, label: 'DO', attribute: 'delivery_order' },
        { id: 7, label: 'IV', attribute: 'invoice' },
        { id: 8, label: 'CD', attribute: 'crdr' },
    ],
};
export const aexTabConfig = {
    hasSplit: false,
    hasSecondTable: false,
    minHeight: 560,
    height: 'auto',
    columns: ['aexHblCols', null, 'aexAliasCols', 'aexHblGroupingModel', null, 'aexAliasGroupingModel', null],

    houseData: 'aexHblUpdateForm',
    containerData: 'aexContainerUpdateForm',
    presetData: 'aexPresetUpdateForm',

    tableName: ['il_air_export', 'il_air_export_hbl', 'il_air_export_hbl_alias'],
    keyName: ['il_air_export_id', 'il_air_export_hbl_id'],

    addReducer: ['', 'addAexHBL', 'addAexContainer', ''],
    updateReducer: ['setAexMainUpdateData', 'setAexHblFormData', 'setAexContainerFormData', ''],
    deleteReducer: ['', 'deleteAexHBL', 'deleteAexContainer', ''],

    newHBL: {
        hawb: '',
        il_trade_partner_id_shipper: '',
        il_trade_partner_id_consignee: '',
        hawb_link: '',
        pre_alert: 'Not Sent',
        invoice: 'Pending',
        invoice_link: [],
        invoice_date: null,
        crdr: 'Pending',
        crdr_link: [],
        crdr_date: null,
    },
    newCNTR: {
        alias: '',
        il_opus_vessel_id: '',
        quantity: 0,
        il_opus_volume_unit_id: '',
        weight: 0,
        il_location_id_pick_up: '',
        il_trade_partner_id: '',
        delivery_order: '-',
        deliver_order_link: '',
        stages: 'Pending',
        stages_date: null,
    },

    presetTableName: 'il_preset_air_export',
    presetColumn: aex_preset_columns,
    checkboxKeys: aex_preset_keys,
    preset: [
        { id: 1, label: 'BK', attribute: 'booking_confirmation' },
        { id: 2, label: 'DO', attribute: 'delivery_order' },
        { id: 3, label: 'SI', attribute: 'shipping_instruction' },
        { id: 4, label: 'PC', attribute: 'portcut' },
        { id: 5, label: 'AF', attribute: 'air_freight' },
        { id: 6, label: 'IV', attribute: 'invoice' },
        { id: 7, label: 'CD', attribute: 'crdr' },
    ],
};
export const truckingTabConfig = {
    presetData: 'truckingPresetUpdateForm',
    minHeight: 355,
    height: 'auto',
    addReducer: ['', 'addTruckingBOL', '', ''],
    updateReducer: ['setTruckingMainUpdateData', 'setBolUpdateData', '', ''],
    deleteReducer: ['', 'deleteBOL', '', ''],

    newBOL: {
        alias: '',
        quantity: 0,
        il_opus_volume_unit_id: '',
        weight: 0,
        il_trade_partner_id: '',
        delivery_order: '-',
        delivery_order_link: '',
        customs: 'Pending',
        customs_hold: '-',
        customs_link: '',
        customs_other: '',
        proof: 'Waiting',
        proof_link: '',
        proof_date: null,
    },

    presetTableName: 'il_preset_ftl_ltl',
    presetColumn: trucking_preset_columns,
    checkboxKeys: trucking_preset_keys,
    preset: [
        { id: 1, label: 'DO', attribute: 'delivery_order' },
        { id: 3, label: 'C', attribute: 'customs' },
        { id: 7, label: 'IV', attribute: 'invoice' },
        { id: 8, label: 'CD', attribute: 'crdr' },
    ],
};
